import { useContext, useEffect } from "react";

import { Route, useLocation, useNavigate } from "react-router-dom";

import AllHistoryView from "@/components/message/AllHistoryView";
import ChatView from "@/components/message/ChatView";
import MessageSettings from "@/components/message/MessageSettings";
import { AuthStateContext } from "@/contexts/AuthContext";
import ProtectedPage from "@/ProtectedPage";

const RubiMessageRedirectToOrgURL = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { currentUser } = useContext(AuthStateContext);

  useEffect(() => {
    const newPath = pathname.replace(
      "/rubimessage",
      `/rubimessage/${currentUser?.rubi_org_id}`,
    );
    navigate(newPath);
  }, []);
  return <></>;
};

export const rubiMessageRoutes = [
  // Start Chat Page - Enter phone number to start a conversation. Renders the
  // same view as the conversation route below (without a :phoneNumber) so the
  // message box keeps any template picked here once a number is entered.
  <Route
    key="rubimessage-start"
    path="rubimessage/:orgId"
    element={
      <ProtectedPage>
        <ChatView />
      </ProtectedPage>
    }
  />,

  // All History - Audit view of conversations grouped by messaging user
  <Route
    key="rubimessage-history"
    path="rubimessage/:orgId/history"
    element={
      <ProtectedPage>
        <AllHistoryView />
      </ProtectedPage>
    }
  />,
  <Route
    key="rubimessage-history-user"
    path="rubimessage/:orgId/history/:rubiUserId"
    element={
      <ProtectedPage>
        <AllHistoryView />
      </ProtectedPage>
    }
  />,

  // Settings Page
  <Route
    key="rubimessage-settings"
    path="rubimessage/:orgId/settings"
    element={
      <ProtectedPage>
        <MessageSettings />
      </ProtectedPage>
    }
  />,

  // Conversation View - Chat interface with message history and templates
  <Route
    key="rubimessage-conversation"
    path="rubimessage/:orgId/conversation/:phoneNumber"
    element={
      <ProtectedPage>
        <ChatView />
      </ProtectedPage>
    }
  />,

  // Redirect any /rubimessage/* paths without orgId to include orgId
  <Route
    key="rubimessage-redirect"
    path="rubimessage/*"
    element={
      <ProtectedPage>
        <RubiMessageRedirectToOrgURL />
      </ProtectedPage>
    }
  />,
];
